import React from "react";
import { Link } from "react-router-dom";
import { Star, Clock, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { inr } from "../lib/format";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  return (
    <div className="group relative bg-white rounded-[var(--radius)] overflow-hidden bakery-shadow hover-lift">
      <Link to={`/products/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-[#F6E7DA]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          {product.bestseller && (
            <span className="absolute top-3 left-3 bg-[#D46A8A] text-white text-[11px] font-semibold px-2.5 py-1 rounded-full">Bestseller</span>
          )}
          {product.mrp > product.price && (
            <span className="absolute top-3 right-3 bg-[#6B4226] text-white text-[11px] font-semibold px-2.5 py-1 rounded-full">
              {Math.round(((product.mrp - product.price) / product.mrp) * 100)}% OFF
            </span>
          )}
        </div>
      </Link>

      <div className="relative p-4">
        <button
          onClick={() => addItem(product)}
          className="absolute -top-6 right-4 w-12 h-12 rounded-full bg-[#D46A8A] text-white grid place-items-center bakery-shadow hover:bg-[#c25a7b] hover:scale-110 transition-all duration-300 z-10"
          aria-label="Add to cart"
          data-testid={`product-add-to-cart-${product.id}`}
        >
          <Plus size={22} />
        </button>
        <Link to={`/products/${product.slug}`}>
          <h3 className="font-display text-base font-semibold text-[#3A2417] leading-tight line-clamp-1 group-hover:text-[#D46A8A] transition-colors">
            {product.name}
          </h3>
        </Link>
        <p className="text-xs text-[#B07A5C] mt-1">{product.flavor} · {product.weight}</p>

        <div className="flex items-center gap-1 mt-2">
          <Star size={14} className="fill-[#E8A6B8] text-[#E8A6B8]" />
          <span className="text-xs font-medium text-[#6B4226]">{product.rating}</span>
          <span className="text-xs text-[#B07A5C]">({product.reviews})</span>
        </div>

        <div className="flex items-center gap-1 text-xs text-[#7a9a5b] mt-1.5">
          <Clock size={13} /> Earliest delivery: <span className="font-medium">Tomorrow</span>
        </div>

        <div className="flex items-center gap-2 mt-3">
          <span className="font-semibold text-[#3A2417]">{inr(product.price)}</span>
          {product.mrp > product.price && (
            <span className="text-sm text-[#B07A5C] line-through">{inr(product.mrp)}</span>
          )}
          {/Pc|piece/i.test(product.weight || "") && (
            <span className="text-xs text-[#B07A5C]">/ piece</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
